import {
    Github,
    Linkedin,
    Instagram,
    Facebook,
    Globe,
    Twitter,
} from "lucide-react";

const socialLinks = [
    {
        name: "Portfolio",
        href: "https://ashkangolzad.ir",
        icon: Globe,
    },
    {
        name: "GitHub",
        href: "https://github.com/ashkangl",
        icon: Github,
    },
    {
        name: "LinkedIn",
        href: "https://linkedin.com/in/ashkan-golzad",
        icon: Linkedin,
    },
    {
        name: "Instagram",
        href: "https://instagram.com",
        icon: Instagram,
    },
    {
        name: "Facebook",
        href: "https://facebook.com",
        icon: Facebook,
    },
    {
        name: "X",
        href: "https://x.com",
        icon: Twitter,
    },
];

const Footer = () => {
    return (
        <footer className="border-t border-gray-200 bg-gray-50 dark:border-gray-800 dark:bg-gray-950">
            
            <div className="mx-auto max-w-[1600px] px-6 py-2 md:px-12 lg:px-20">

                <div className="mt-2 pb-2 flex flex-col gap-6 pt-2 md:flex-row md:items-center md:justify-between dark:border-gray-800">

                    <div className="flex flex-wrap items-center gap-3">

                        {socialLinks.map((social) => {
                            const Icon = social.icon;

                            return (
                                <a
                                    key={social.name}
                                    href={social.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={social.name}
                                    className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 text-gray-600 transition-all duration-300 hover:-translate-y-1 hover:border-blue-600 hover:bg-blue-600 hover:text-white dark:border-gray-700 dark:text-gray-300"
                                >
                                    <Icon size={18} />
                                </a>
                            );
                        })}

                    </div>

                    {/* Copyright */}
                    <p className="text-sm text-gray-500">
                        © {new Date().getFullYear()} Ashkan Golzad. All rights reserved.
                    </p>

                </div>

            </div>

        </footer>
    );
};

export default Footer;